// extracted by mini-css-extract-plugin
export var locationCard = "_gf-0";